var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownSelectMultiple, SelectOption, TagDeselectItem, TagSelectItem, TagSelectSuggestion, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { currentAgentRoles } from 'components/shared/agentRole';
import { stringToHexColor } from 'components/shared/util/color';
import styles from './tagsSelect.module.scss';
const getDeactivatedTagIds = (tags) => tags.filter((tag) => tag.is_deactivated).map((tag) => tag.id);
export class TagsSelect extends PureComponent {
    static addId(tag) {
        return Object.assign(Object.assign({}, tag), { id: tag.name });
    }
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
    }
    createTag(name) {
        return __awaiter(this, void 0, void 0, function* () {
            analytics.tagSelectCreateNewTagClicked({
                tagName: name,
                component: 'TagsSelect',
            });
            const { selectTag, tags: { create }, } = this.props;
            const tag = yield create({ name, color: stringToHexColor(name) });
            selectTag(tag.data);
        });
    }
    onToggle(isOpen, isFirstOpen) {
        var _a, _b;
        (_b = (_a = this.props).onDropdownToggle) === null || _b === void 0 ? void 0 : _b.call(_a, isOpen, isFirstOpen);
        if (isFirstOpen) {
            this.setState({ isDropdownOpen: true }, () => {
                this.props.tags.filterByChange('active');
            });
        }
        else if (isOpen) {
            this.setState({ isDropdownOpen: true });
        }
        else if (!isOpen && this.props.tags.searchTerm !== '') {
            this.setState({ isDropdownOpen: false }, () => {
                this.props.tags.searchTermChange('');
            });
        }
        else if (!isOpen) {
            this.setState({ isDropdownOpen: false });
        }
    }
    toggleDeactivatedTags() {
        const { tags, onIncludeDeactivatedTagsToggle } = this.props;
        onIncludeDeactivatedTagsToggle === null || onIncludeDeactivatedTagsToggle === void 0 ? void 0 : onIncludeDeactivatedTagsToggle(tags.filterBy === 'active');
        tags.filterByChange(tags.filterBy === 'active' ? null : 'active');
    }
    renderSuggestion(search) {
        return (_jsxs("div", Object.assign({ className: styles.suggestion }, { children: [_jsx("div", { className: styles.tagColor, style: { backgroundColor: stringToHexColor(search) } }), _jsxs("div", { children: ["Create \"", search, "\" tag"] })] })));
    }
    render() {
        const { tags, selectedItems, selectTag, deselectTag, buttonText, allowCreatingNewTag = false, agent, buttonProps, className, } = this.props;
        const { items, searchTermChange, getItemsAsyncStatus, searchTerm, hasNextPage, hasPreviousPage, nextPage, previousPage, filterBy, } = tags;
        const tagsWithId = items.map(TagsSelect.addId);
        const selectedTagsWithId = selectedItems.map(TagsSelect.addId);
        const tooltipItems = [...tagsWithId, ...selectedTagsWithId];
        const filteredTags = tagsWithId.filter((tag) => !selectedTagsWithId.filter((selectedTag) => tag.id === selectedTag.id)
            .length);
        const disabledTags = [
            ...getDeactivatedTagIds(tagsWithId),
            ...getDeactivatedTagIds(selectedTagsWithId),
        ];
        const { at_least_systemadmin } = currentAgentRoles(agent);
        const createTagAllowedAndPermitted = allowCreatingNewTag && at_least_systemadmin;
        const shouldShowSuggestion = searchTerm.trim().length > 1 &&
            createTagAllowedAndPermitted &&
            !items.some(({ name }) => name.toLowerCase() === searchTerm.toLowerCase());
        return (_jsx(DropdownSelectMultiple, { className: classnames(styles.tagsWrapper, className), selectedItems: selectedTagsWithId, onRemove: deselectTag, containerProps: { className: styles.tagsSelectContainer }, items: filteredTags, itemComponent: TagSelectItem, tooltipItems: Object.assign({}, ...tooltipItems.map((t) => ({
                [t.id]: { content: t.name, dark: true },
            }))), onSearch: searchTermChange, suggestionComponent: shouldShowSuggestion ? TagSelectSuggestion : undefined, renderSuggestion: this.renderSuggestion, onSuggest: this.createTag, onSelect: selectTag, onToggle: this.onToggle, keepOpen: true, hasSearch: true, noArrow: false, previewItemsNumber: 3, buttonProps: Object.assign({ isLoading: getItemsAsyncStatus === 'loading', variant: 'tertiary' }, buttonProps), emptyMessage: searchTerm ? 'No tags found' : 'No tags available', buttonText: buttonText, MoreItemsItemComponent: TagDeselectItem, pagination: {
                nextEnable: hasNextPage,
                previousEnable: hasPreviousPage,
                onNext: nextPage,
                onPrevious: previousPage,
            }, disabledItems: disabledTags, optionComponent: _jsx(SelectOption, { name: "Include deactivated tags", checked: filterBy === null, onChange: this.toggleDeactivatedTags }), icon: "tag" }));
    }
}
TagsSelect.defaultProps = {
    buttonText: 'Add tag',
};
__decorate([
    boundMethod
], TagsSelect.prototype, "createTag", null);
__decorate([
    boundMethod
], TagsSelect.prototype, "onToggle", null);
__decorate([
    boundMethod
], TagsSelect.prototype, "toggleDeactivatedTags", null);
